// src/api/dashboard.ts

import { apiClient } from "helpers/api_helper";

export interface DashboardStats {
  employee_stats: {
    total: number;
    active: number;
    inactive: number;
    resigned: number;
    terminated: number;
  };
  today_attendance: {
    present: number;
    absent: number;
    total_employees: number;
    present_employees: Array<{
      id: number;
      name: string;
      employee_code: string;
      designation: string | null;
      check_in_time: string;
      check_out_time: string | null;
      status: "checked_in" | "checked_out";
    }>;
    absent_employees: Array<{
      id: number;
      name: string;
      employee_code: string;
      designation: string | null;
    }>;
  };
  department_stats: Array<{
    designation: string;
    count: number;
  }>;
}

export const dashboardApi = {
  getStats: (
    year?: number,
    month?: number,
  ): Promise<{ success: boolean; data: DashboardStats; message: string }> => {
    const params = new URLSearchParams();
    if (year) params.append("year", year.toString());
    if (month) params.append("month", month.toString());
    const queryString = params.toString();
    const url = queryString
      ? `/dashboard/stats?${queryString}`
      : "/dashboard/stats";
    return apiClient.get(url);
  },

  getQuickStats: (): Promise<any> => {
    return apiClient.get("/dashboard/quick-stats");
  },

  getAttendanceByDate: (date: string): Promise<any> => {
    return apiClient.get(`/dashboard/attendance/${date}`);
  },

  getMonthlySummary: (year: number, month: number): Promise<any> => {
    return apiClient.get(
      `/dashboard/monthly-summary?year=${year}&month=${month}`,
    );
  },
};
